"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Mark = exports.Label = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* icon color is used for the unselected state */
var Mark = _styledComponents["default"].span.withConfig({
  displayName: "RadioCheckboxParts__Mark",
  componentId: "sc-1n7owiw-0"
})(["display:block;height:", ";width:", ";border:1px solid ", ";color:white;position:absolute;top:50%;transform:translateY(-50%);"], function (props) {
  return props.theme.fields.radioCheckIconSize;
}, function (props) {
  return props.theme.fields.radioCheckIconSize;
}, function (props) {
  return props.theme.colors.radioCheckInactive;
});
exports.Mark = Mark;
var Label = _styledComponents["default"].label.withConfig({
  displayName: "RadioCheckboxParts__Label",
  componentId: "sc-1n7owiw-1"
})(["display:block;width:auto;position:relative;line-height:", ";padding:0 ", ";padding-left:calc( ", " + ", " );", "{left:0;}", " color:", ";cursor:pointer;", ";"], function (props) {
  return props.theme.fields.radioCheckIconSize;
}, function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return props.theme.fields.radioCheckIconSize;
}, function (props) {
  return props.theme.spaces.xs;
}, Mark, function (props) {
  return props.noContent && (0, _styledComponents.css)(["padding:0;", "{position:relative;top:unset;transform:none;}"], Mark);
}, function (props) {
  return props.theme.colors.textSecondary;
}, function (props) {
  return props.isHighlighted && (0, _styledComponents.css)(["color:", ";"], props.theme.colors.success_2);
});
exports.Label = Label;
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "RadioCheckboxParts__Wrapper",
  componentId: "sc-1n7owiw-2"
})(["display:inline-block;font-size:", ";vertical-align:middle;input[type=\"radio\"],input[type=\"checkbox\"]{outline:none;visibility:hidden;position:absolute;left:-9999px;}input:checked ~ ", "{transition:all 0.2s ease-in;}", ":hover ", "{border-color:", ";}input:checked ~ ", " ", "{border-color:", ";transition:all 0.2s ease-in;}input:disabled ~ ", "{opacity:", ";cursor:not-allowed;&:hover ", "{border-color:", ";}}input:checked:disabled ~ ", " ", "{border-color:", ";}"], function (props) {
  return props.theme.fields.fontSize;
}, Label, Label, Mark, function (props) {
  return (0, _helpers.getColor)(props, "color", "focus");
}, Label, Mark, function (props) {
  return (0, _helpers.getColor)(props, "color", "focus");
}, Label, function (props) {
  return props.disabledOpacity || "0.5";
}, Mark, function (props) {
  return props.theme.colors.radioCheckInactive;
}, Label, Mark, function (props) {
  return (0, _helpers.getColor)(props, "color", "focus");
});
exports.Wrapper = Wrapper;